import React from 'react';
import { IndexRoute, Route } from 'react-router';

import { routeStrings as routes } from 'config/routes';
import { getComponentForImport } from 'utils/routeHelpers';
import { guidelinePdfClicked } from 'actions/analytics';
import { userLoggedOut } from 'actions/auth';

import AccountSetupRequired from 'components/AccountSetup/AccountSetupRequired';
import LoginRequired from 'components/common/LoginRequired';
import MobileOverlay from 'components/MobileOverlay';
import SidenavContainer from 'components/SidenavContainer';
import MainComponent from 'components/MainComponent';
import TopnavContainer, {
  HOMEPAGE_NAV_TYPE,
  INTERNAL_NAV_TYPE,
} from 'components/TopnavContainer';
import NotFound from 'components/NotFound';
import ExternalRedirect from 'components/Redirects/ExternalRedirect';
import RedirectReturn from 'components/Redirects/RedirectReturn';

// chunk: home
const home = () => import(/* webpackChunkName: "home" */ 'components/Home');

// one-off pages
const terms = () => import(/* webpackChunkName: "terms" */ 'components/Terms');
const waitlist = () => import(/* webpackChunkName: "waitlist" */ 'components/Waitlist');
const faq = () => import(/* webpackChunkName: "home" */ './components/Faq');

// chunk: build-ad
const buildAd = () =>
  import(/* webpackChunkName: "build-ad" */ 'components/BuildAd');
const campaignStep = () =>
  import(/* webpackChunkName: "build-ad" */ 'components/BuildAd/Steps/CampaignStep');
const audienceStep = () =>
  import(/* webpackChunkName: "build-ad" */ 'components/BuildAd/Steps/AudienceStep');
const adCreationStep = () =>
  import(/* webpackChunkName: "build-ad" */ 'components/BuildAd/Steps/AdCreationStep');

// chunk: browse-ads
const newBrowseAds = () =>
  import(/* webpackChunkName: "browse-ads" */ 'components/BrowseAds');
const adDetailView = () =>
  import(/* webpackChunkName: "browse-ads" */ 'components/AdDetailView');

// chunk: account-settings
const accountSettings = () =>
  import(/* webpackChunkName: "account-settings" */ 'components/AccountSettings');

export default (
  <Route path={routes.MAIN} component={MainComponent}>
    <Route component={LoginRequired}>
      <Route component={MobileOverlay}>
        <Route component={AccountSetupRequired}>
          <Route component={SidenavContainer}>
            <Route
              path={routes.BROWSE_ADS}
              getComponent={getComponentForImport(newBrowseAds)}
            >
              <Route
                path={routes.BROWSE_ADS_ADVIEW}
                getComponent={getComponentForImport(adDetailView)}
              />
            </Route>
            <Route
              path={routes.ACCOUNT_SETTINGS}
              getComponent={getComponentForImport(accountSettings)}
            />
            <Route
              path={routes.BUILD_AD}
              getComponent={getComponentForImport(buildAd)}
            >
              <IndexRoute
                getComponent={getComponentForImport(campaignStep)}
              />
              <Route
                path={routes.CAMPAIGN_STEP}
                getComponent={getComponentForImport(campaignStep)}
              />
              <Route
                path={routes.AUDIENCE_STEP}
                getComponent={getComponentForImport(audienceStep)}
              />
              <Route
                path={routes.ADCREATION_STEP}
                getComponent={getComponentForImport(adCreationStep)}
              />
            </Route>
          </Route>
        </Route>
      </Route>
    </Route>

    {
      /**
       * the following routes are not wrapped in any nav.
       */
    }
    <Route
      component={ExternalRedirect}
      path={routes.LOGIN}
      redirectUrl={`https://accounts.spotify.com/?continue=${window.location.origin}`}
    />
    <Route
      component={ExternalRedirect}
      path={routes.LOGOUT}
      redirectUrl={`https://accounts.spotify.com/logout?continue=${window.location.origin}`}
      onRedirectAction={userLoggedOut}
    />
    <Route
      component={ExternalRedirect}
      path={routes.SIGNUP}
      redirectUrl={`https://spotify.com/signup?forward-url=${window.location.origin}`}
    />
    <Route
      component={ExternalRedirect}
      path={routes.ACCOUNT}
      redirectUrl="https://www.spotify.com/us/account/overview"
    />
    <Route
      component={ExternalRedirect}
      path={routes.CREATIVE_GUIDELINES}
      redirectUrl="https://adstudio.scdn.co/assets/landingpage/ad-studio-guidelines-1-9.pdf"
      onRedirectAction={guidelinePdfClicked}
    />
    <Route
      component={ExternalRedirect}
      path={routes.FEEDBACK}
      redirectUrl="https://docs.google.com/a/spotify.com/forms/d/e/1FAIpQLSdNNcS2m7u8VQNsAzAJGIHTS6Z1m38Lw-BFArEt0V8BQooPAA/viewform"
    />
    <Route
      component={ExternalRedirect}
      path={routes.BETA_TERMS}
      redirectUrl="https://www.spotify.com/us/brands/legal/advertiser-terms-and-conditions/"
    />

    <Route
      component={RedirectReturn}
      path={routes.REDIRECT}
    />

    {
      /**
       * these routes will receive the old topnav treatment. only suitable for
       * PR pages such as FAQ, home, etc.
       */
    }
    <Route component={TopnavContainer} navType={INTERNAL_NAV_TYPE}>
      <Route path={routes.WAITLIST} getComponent={getComponentForImport(waitlist)} />
      <Route path={routes.TERMS} getComponent={getComponentForImport(terms)} />
    </Route>

    <Route component={TopnavContainer} navType={HOMEPAGE_NAV_TYPE}>
      <IndexRoute getComponent={getComponentForImport(home)} />
      <Route path={routes.FAQ} getComponent={getComponentForImport(faq)} />
      <Route path={routes.NOT_FOUND} component={NotFound} />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js